import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button as Button } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

type Props = {
  selectedCount: number
  eligibleCount: number
  onCancel: () => void
  onConfirm: () => void
}

const BulkActivateModal = ({ selectedCount, eligibleCount, onCancel, onConfirm }: Props) => {
  const { company } = useCurrentSession()

  return (
    <Modal
      title={i18n.t('employees.activate.bulk_modal.some_in_inactivity_title', {
        defaultValue: 'Some of the selected employees are in an inactivity period',
      })}
      description={i18n.t('employees.activate.bulk_modal.some_in_inactivity_description', {
        selected: selectedCount,
        eligible: eligibleCount,
        defaultValue:
          "Of the %{selected} selected employees, %{eligible} are currently in an activity period. Click 'Continue' to proceed with the eligible employees.",
      })}
      illustration="document-edit"
      onClose={onCancel}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button variant="outline" size="md" label={i18n.t('common.cancel')} onClick={onCancel} />
          <Button
            size="md"
            label={i18n.t('common.continue')}
            onClick={() => {
              // Track Bulk Activate Submit
              track(trackingEvents.bulkActivate.submit, {
                company_id: company.id,
                selected_count: selectedCount,
                submitted_count: eligibleCount,
                ineligible_count: selectedCount - eligibleCount,
              })

              onConfirm()
            }}
          />
        </Box>
      }
    />
  )
}

export default BulkActivateModal
